import React, { useState, useEffect } from 'react';
import { Checkbox } from '@mui/material';

const CustomRadioBox = props => {
  const { checked: propsChecked, name, onChange, setValue = () => {} } = props;
  const [checked, setChecked] = useState(!!propsChecked);

  useEffect(() => {
    setChecked(propsChecked);
  }, [propsChecked]);

  return (
    <div style={{ position: 'relative' }}>
      <Checkbox
        name={name}
        checked={checked}
        onClick={
          onChange ||
          (() => {
            setChecked(p => !p);
            setValue(name, !checked);
          })
        }
        // className="custom-checkbox"
        sx={{ color: '#0F7F85' }}
        style={{ opacity: 0, zIndex: 2 }}
        {...props}
      />
      <img
        src={checked ? '/images/icons/radio-checked.svg' : '/images/icons/radio-unchecked.svg'}
        alt="checkbox"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </div>
  );
};

export default CustomRadioBox;
